module.exports = __webpack_public_path__ + "img/evtc-inspector.bc78acb6.png";